export default __webpack_public_path__ + "static/account-icon-cba4d0631a0c0addc075ee8d47b5403d.svg";